import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Box, 
  Button, 
  FormControlLabel,
  Switch,
  Typography,
  Divider
} from '@mui/material';
import { useSignupStore } from '../../stores/SignupStore';

function SiteConfiguration() {
  const navigate = useNavigate();
  
  const { 
    requireApproval,
    isSendWhatsappByDefault,
    setRequireApproval,
    setIsSendWhatsappByDefault
  } = useSignupStore();

  const handleNext = () => {
    navigate('/signup/phone-verification');
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        群組設定
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        設定您的群組運作方式，這些設定之後可以在群組管理中修改
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={requireApproval}
            onChange={(e) => setRequireApproval(e.target.checked)}
          />
        }
        label={
          <Box>
            <Typography variant="body1">需要審批</Typography>
            <Typography variant="caption" color="text.secondary">
              開啟後，新報名需要管理員審批才能確認
            </Typography>
          </Box>
        }
        sx={{ mb: 3, alignItems: 'flex-start', display: 'flex' }}
      />

      <FormControlLabel
        control={
          <Switch
            checked={isSendWhatsappByDefault}
            onChange={(e) => setIsSendWhatsappByDefault(e.target.checked)}
          />
        }
        label={
          <Box>
            <Typography variant="body1">預設發送 WhatsApp 通知</Typography>
            <Typography variant="caption" color="text.secondary">
              開啟後，創建活動時會預設勾選發送 WhatsApp 通知
            </Typography>
          </Box>
        }
        sx={{ mb: 3, alignItems: 'flex-start', display: 'flex' }}
      />

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <Button
          variant="outlined"
          onClick={() => navigate('/signup/personal-info')}
        >
          上一步
        </Button>
        <Button
          variant="contained"
          onClick={handleNext}
        >
          下一步
        </Button>
      </Box>
    </Box>
  );
}

export default SiteConfiguration;
